import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCompanies } from '../../../store/actions/company';
import MaterialTable, { Column } from 'material-table';
import { Snackbar } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { CompanyState } from '../../../store/reducers/company';
import { useHistory } from 'react-router-dom';
import { Company } from '../../../models/Company';

interface RootState {
  company: CompanyState;
}

const Companies: React.FC = () => {
  const columns: Column<Company>[] = [
    { title: 'Company Name', field: 'companyName', searchable: true },
    { title: 'Office Email', field: 'officeEmail', searchable: false },
  ];

  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [error, setError] = useState(null);
  const history = useHistory();

  const companies = useSelector((state: RootState) => state.company.companies);

  useEffect(() => {
    const fetchCompanies = async () => {
      setIsLoading(true);
      setError(null);
      try {
        await dispatch(getCompanies());
      } catch (error) {
        setError(error.message);
      }
      setIsLoading(false);
    };
    fetchCompanies();
  }, [dispatch]);

  const rowClickHandler = (
    event: React.MouseEvent<Element, MouseEvent> | undefined,
    rowData:
      | {
          id: string;
        }
      | undefined
  ) => {
    history.push('/company/' + rowData!!.id);
  };

  const getPageSize = (): number => {
    if (companies.length < 5) {
      return 5;
    } else if (companies.length < 10) {
      return 10;
    } else if (companies.length < 15) {
      return 15;
    } else {
      return 20;
    }
  };

  return (
    <>
      <MaterialTable
        isLoading={isLoading}
        key={companies.length}
        localization={{ toolbar: { searchPlaceholder: 'Search Company Name' } }}
        options={{
          search: true,
          pageSize: getPageSize(),
          pageSizeOptions: [],
        }}
        columns={columns}
        data={companies.map((company) => {
          return {
            companyName: company.companyName,
            officeEmail: company.officeEmail,
            id: company.id,
          };
        })}
        title="Companies"
        onRowClick={(event, rowData) => rowClickHandler(event, rowData)}
      />

      <Snackbar
        open={showSnackbar}
        autoHideDuration={3000}
        onClose={() => setShowSnackbar(false)}
      >
        <Alert
          onClose={() => setShowSnackbar(false)}
          severity={error ? 'error' : 'success'}
        >
          {error ? error : 'Company profile is created.'}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Companies;
